import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Lock } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("af_token", data.token);
      toast.success("Accesso effettuato");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl bg-[#0A0A0A] border border-white/10 px-4 py-3.5 text-white placeholder:text-zinc-600 focus:border-blue-500 focus:outline-none transition-colors";

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6 grid-bg">
      <div className="noise-overlay" />
      <div className="w-full max-w-md">
        <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-white transition-colors mb-8">
          <ArrowLeft size={16} /> Torna al sito
        </Link>
        <div className="rounded-3xl border border-white/10 bg-[#0A0A0A] p-8">
          <div className="w-12 h-12 rounded-2xl bg-blue-500/10 border border-blue-500/30 flex items-center justify-center mb-6">
            <Lock size={22} weight="duotone" className="text-blue-400" />
          </div>
          <h1 className="font-heading font-bold text-2xl text-white">Area Riservata</h1>
          <p className="text-sm text-zinc-500 mt-1">AppForge Studio — Admin</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <input data-testid="login-email" type="email" className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input data-testid="login-password" type="password" className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full rounded-full bg-blue-500 text-white font-semibold py-3.5 hover:bg-blue-400 transition-colors disabled:opacity-60">
              {loading ? "Accesso..." : "Accedi"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
